import script from "./agents-nav-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./agents-nav-bar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__